import React from 'react';

import { useNavigate } from 'react-router-dom';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/lab/LoadingButton';

import { useMutation, useQueryClient } from 'react-query';

import { deletePayoutRequest } from 'api/payoutrequests';

interface ConfirmDeleteDialogProps extends DialogProps {
    payoutRequestId: string;
    onDeleted?: () => void;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({ onDeleted, ...props }) => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const deleteMutation = useMutation(() => deletePayoutRequest(props.payoutRequestId), {
        onSuccess: () => {
            if (onDeleted) {
                onDeleted();
            } else {
                navigate('/payoutrequests');
            }
            queryClient.invalidateQueries(['payoutrequest', props.payoutRequestId]);
        }
    });

    return (
        <Dialog {...props} maxWidth="sm">
            <DialogTitle>Удалить запрос на расчёт?</DialogTitle>
            <DialogActions>
                <Button color="secondary" disabled={deleteMutation.isLoading} onClick={() => props.onClose({}, 'backdropClick')}>
                    Отмена
                </Button>
                <Button color="primary" disabled={deleteMutation.isLoading} onClick={() => deleteMutation.mutate()}>
                    Подтвердить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteDialog;
